/* eslint-disable graphql/template-strings */
import { gql } from '@apollo/client';

export const DestinationFields = gql`
  fragment DestinationFields on Destination {
    destinationId
    type
    name
    isValid
    thumbnail
  }
`;

export const StreamDestinationFields = gql`
  fragment StreamDestinationFields on StreamDestination {
    destinationId
    converterId
    status
    type
    name
    isEnabled
  }
`;

export const StreamOverlayFields = gql`
  fragment StreamOverlayFields on Stream {
    overlayTitle
    overlayDescription
    overlayConfig {
      templateId
      sponsorLogoKey
      ribbonText
      liveMatchState {
        currentMatchupId
        currentRound
        roundTimerSeconds
        isTimerRunning
        winnerCorner
        fighterA
        fighterB
        weightClass
        rounds
        roundDurationSeconds
      }
    }
  }
`;

export const HostFields = gql`
  fragment HostFields on Host {
    id
    uid
    name
    email
    slug
    audience
    status
    acceptanceStatus
    deletedAt
    acceptedAt
    enteredAt
  }
`;

export const HostPublicFields = gql`
  fragment HostPublicFields on Host {
    id
    uid
    name
    slug
    audience
    status
    acceptanceStatus
    deletedAt
    acceptedAt
    enteredAt
  }
`;
